import '../css/style.scss'
import heroControls from './heroControls'
import gMap from './googleMaps'
import mobileMenu from './mobileMenu'
import subMenu from './subMenu'
import Interactive from './interactive'

window.addEventListener('load', () => {
  if (document.getElementById('g-map')) {
    const g_map = new gMap()
  }

  const mobile_menu = new mobileMenu()
  const sub_menu = new subMenu()

  const interactiveElem = document.querySelector('.interactive')
  if (interactiveElem) {
    const interactive = new Interactive(interactiveElem)
  }

  const heroVideo = document.querySelector('.hero-video video')
  const heroButton = document.querySelector('.video-button')
  const heroText = document.querySelector('.hero-text')
  const heroImages = document.querySelectorAll('#imageContainer img')
  if (heroVideo && heroButton && heroText && heroImages) {
    const hero = new heroControls(heroText, heroImages, heroButton, heroVideo)
  }

  const formSubmit = document.querySelector('.wpcf7-submit')
  if (formSubmit) {
    formSubmit.addEventListener('click', () => {
      formSubmit.classList.toggle('sent')
      formSubmit.style.backgroundColor = '#fe8e3c'
      formSubmit.value = 'SUBMITTED'
    })
  }
})
